import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import {
  FindProjectMembersResponse,
  FindProjectMembersQuery,
} from '@/@types/ProjectMember';

const VuexModule = createModule({
  namespaced: 'theoryApiProjectMembersStore',
  strict: false,
});

export class ProjectMembersStore extends VuexModule {
  private readonly projectMembersRepository = RepositoryFactory.theoryApi.projectMembersRepository();
  /** state */
  private projectMembers: FindProjectMembersResponse | null = null;
  /** プロジェクトホーム画面用 */
  private homeProjectMembers: FindProjectMembersResponse | null = null;

  @mutation
  private setProjectMembers(payload: FindProjectMembersResponse | null) {
    this.projectMembers = payload;
  }

  @mutation
  private setHomeProjectMembers(payload: FindProjectMembersResponse | null) {
    this.homeProjectMembers = payload;
  }

  /** プロジェクトメンバー一覧取得 */
  @action
  async fetchProjectMembers(query: FindProjectMembersQuery) {
    const results = await this.projectMembersRepository.findProjectMembers(query);
    this.setProjectMembers(results);
  }

  /** プロジェクトメンバー一覧取得 ホーム画面用*/
  @action
  async fetchProjectMembersById(projectId: number) {
    const results = await this.projectMembersRepository.fetchProjectMembersById(projectId);
    this.setHomeProjectMembers(results);
  }

  @action
  async deleteProjectMembers() {
    this.setProjectMembers(null);
  }

  @action
  async deleteHomeProjectMembers() {
    this.setHomeProjectMembers(null);
  }

  get getProjectMembers() {
    return this.projectMembers;
  }

  get getHomeProjectMembers() {
    return this.homeProjectMembers;
  }
}
